import { useEffect, useRef, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getModuleByIdStart } from "../../Store/Slices/formSlice";
import Loader from "../Loader";
import PdfPreviewer from "./pdfPreviewer";
import { convertToIndianWords, formatDateYMD } from "../DateFn";
import { getTemplateStart } from "../../Store/Slices/templateSlice";
import { getItem } from "../../Services/localService";

export const ExportQuotePdf = ({
    showPrintExportModal,
    setShowPrintExportModal,
    templateData,
    selectedRowData,
    printExportModalTitle,
    rowData,
    id,
    selectedRowTableData
}) => {
    const dispatch = useDispatch();
    let currentOrgName = getItem('user')?.organization?.organizationName;
    let currentOrg = useSelector((state) => state?.org)?.companyData?.[0];
    let navbarList = useSelector((state) => state?.forms)?.navbarList;
    let formList = useSelector((state) => state?.forms)?.modules;
    let currentCurrencyData = useSelector((state) => state?.currency)?.data?.[0];

    let [selectedContent, setSelectedContent] = useState('');
    let [selectedTemplateIndex, setSelectedTemplateIndex] = useState('')
    let [fieldList, setFieldList] = useState([]);
    let [showLoader, setShowLoader] = useState(false);
    let [isInitialLoad, setIsInitialLoad] = useState(false);

    useEffect(() => {
        setIsInitialLoad(true);
        if (templateData?.length) {
            setShowLoader(true)
            let defaultTemplateIndex = templateData?.findIndex((x) => x.is_default === true);
            defaultTemplateIndex = defaultTemplateIndex !== -1 ? defaultTemplateIndex : 0;
            if (defaultTemplateIndex >= 0) {
                setSelectedTemplateIndex(defaultTemplateIndex);
                let updatedContent = getDynamicContent(templateData?.[defaultTemplateIndex]?.content, templateData?.[defaultTemplateIndex]?.templateProperties)
                setSelectedContent(updatedContent)
            }
        }
    }, [])

    const formatNumber = (amount) => {
        if (amount)
            return new Intl.NumberFormat(currentCurrencyData?.digit_format, {
                style: "decimal",
                minimumFractionDigits: currentCurrencyData?.decimal_place,
                maximumFractionDigits: currentCurrencyData?.decimal_place,
            }).format(amount);
        else return ''
    };

    const changeCase = (str) => str.charAt(0).toLowerCase() + str.slice(1);

    const cleanPlaceholders = (content) => {
        return content.replace(/\${(.*?)}/g, "$1");
    };

    const replaceOrgLogo = (content) => {
        let element = `<img src=${currentOrg?.profilePicture} alt="org logo" style="width: 150px;" />`
        content = content.replaceAll('${org_logo}', element || '-')
        return content
    }

    const replaceSignName = (content, properties) => {
        content = content.replaceAll('${signature_name}', properties?.other_details?.document_summary?.signature?.signature_name || '')
        return content
    }

    const replaceSignImage = (content, properties) => {
        let element = `<img src="${properties?.other_details?.document_summary?.signature?.signature_image?.fileimage}" style="max-width: 240px; max-height: 240px;" />`
        content = content.replaceAll('${signature_image}', element || '')
        return content
    }

    const replaceOrganization = (content) => {
        content = content.replaceAll('${current_org}', currentOrgName || '-')
        return content
    }

    const replaceSubtotal = (content) => {
        let formattedTotal = formatNumber(selectedRowData?.aggregate_list?.Sub_Total)
        content = content.replaceAll('${Sub Total}', formattedTotal || '-')
        return content
    }

    const replaceDiscount = (content) => {
        content = content.replaceAll('${Discount}', formatNumber(selectedRowData?.aggregate_list?.Discount) || '-')
        return content
    }

    const calculateAmount = (percentage) => {
        let val = Number(selectedRowData?.aggregate_list?.Sub_Total) - Number(selectedRowData?.aggregate_list?.Discount || 0)
        let amt = (percentage / 100) * val;
        return formatNumber(amt)
    };

    const replaceTax = (content) => {
        // content = content.replaceAll('${Tax}', selectedRowData?.aggregate_list?.Tax || '-')
        content = content.replaceAll('${Tax Percentage}', selectedRowData?.aggregate_list?.Tax ? selectedRowData?.aggregate_list?.Tax + '%' : '-')
        content = content.replaceAll('${Tax Amount}', selectedRowData?.aggregate_list?.Tax ? calculateAmount(selectedRowData?.aggregate_list?.Tax) : '-')
        return content
    }

    const replaceAdjustment = (content) => {
        content = content.replaceAll('${Adjustment}', formatNumber(selectedRowData?.aggregate_list?.Adjustment) || '-')
        return content
    }

    const replaceGrandtotal = (content) => {
        let formattedTotal = formatNumber(selectedRowData?.aggregate_list?.Grant_Total)
        content = content.replaceAll('${Grand Total}', formattedTotal || '-')
        content = content.replaceAll('${Symbol}', ` ${currentCurrencyData?.currency_code} ` || '-')
        return content
    }

    const replaceTotalInWord = (content) => {
        if (selectedRowData?.aggregate_list?.Grant_Total) {
            content = content.replaceAll('${TotalInWords}', convertToIndianWords(selectedRowData?.aggregate_list?.Grant_Total))
            return content
        }
    }

    const replaceTotalItems = (content) => {
        content = content.replaceAll('${TotalItems}', selectedRowData?.table_data?.length)
        return content
    }

    const replaceTotalTaxAmount = (content) => {
        const totalAmount = selectedRowTableData?.rowTax.reduce((sum, item) => {
            const amount = Number(item.tax_amount);
            return !isNaN(amount) && item.tax_amount !== "" ? sum + amount : sum;
        }, 0);
        content = content.replaceAll('${TotalTaxAmount}', currentCurrencyData?.currency_code + ' ' + formatNumber(totalAmount))
        return content
    }

    const replaceTableData = (content, i) => {
        const regex = /\${QUOTES\.Item\.([^}]+)}/g;
        let match; const matches = [];
        content = content.replaceAll('${QUOTES.item.S.No}', i + 1)
        while ((match = regex.exec(content)) !== null) {
            matches.push(match[0]);
            let mt = match[0];
            mt = cleanPlaceholders(mt)
            let selectedField = mt.split('.')[2]?.replaceAll(' ', '_')
            let type = typeof (selectedRowData?.table_data[i]?.[selectedField])
            let _field;
            if (type === 'object') {
                _field = selectedRowData?.table_data[i]?.[selectedField]['name']
            } else if (type === 'string' || type === 'number') {
                if (mt === "QUOTES.Item.Total" || mt === "QUOTES.Item.List Price") {
                    // _field = formatNumber(selectedRowData?.table_data[i]?.[selectedField])
                    _field = selectedRowData?.table_data[i]?.[selectedField]
                } else if (mt === "QUOTES.Item.Discount") {
                    if (selectedRowTableData?.rowDiscount?.[i].discount_type === "percentage") {
                        _field = formatNumber(selectedRowTableData?.rowDiscount?.[i].discount_amount)
                    } else {
                        _field = selectedRowData?.table_data[i]?.[selectedField]
                    }
                } else if (mt === "QUOTES.Item.Tax") {
                    _field = selectedRowTableData?.rowTax?.[i].tax_amount ? `${formatNumber(selectedRowTableData?.rowTax?.[i].tax_amount)} (${selectedRowData?.table_data[i]?.[selectedField]}%)` : ''
                } else {
                    _field = selectedRowData?.table_data[i]?.[selectedField]
                }
            }
            let _mt = '${' + mt + '}'
            _field = _field === undefined ? '-' : _field
            content = content.replaceAll(_mt, _field)
        }
        return content
    }

    const replaceElementsByClassMultipleTimes = (htmlString, className) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        const targetElements = doc.getElementsByClassName(className);
        Array.from(targetElements).forEach((el) => {
            let repeatedElements = "";
            for (let i = 0; i < selectedRowData?.table_data?.length; i++) {
                let replacedContent = replaceTableData(targetElements[0].outerHTML, i)
                repeatedElements += replacedContent;
            }
            el.outerHTML = repeatedElements;
        });
        return doc.body.innerHTML;
    };

    const replacePlaceholders = (content) => {
        if (selectedRowData?.table_data?.length > 0) {
            const extractedTableRow = replaceElementsByClassMultipleTimes(content, 'product-item-table-row')
            content = extractedTableRow || content
            selectedRowData?.table_data?.forEach((element, index) => {
                const regex = /\${QUOTES\.Item\.([^}]+)}/g;
                let match; const matches = [];
                while ((match = regex.exec(content)) !== null) {
                    matches.push(match[0]);
                    let mt = match[0];
                    mt = cleanPlaceholders(mt)
                    let selectedField = mt.split('.')[2]?.replaceAll(' ', '_')
                    let type = typeof (element?.[selectedField])
                    let _field;
                    if (type === 'object') {
                        _field = element?.[selectedField]['name']
                    } else if (type === 'string' || type === 'number') {
                        _field = element?.[selectedField]
                    }
                    let _mt = '${' + mt + '}'
                    _field = _field === undefined ? '-' : _field
                    content = content.replaceAll(_mt, _field)
                }
            });
        } else {
            content = null
        }
        return content
    };

    const getDynamicContent = (content, properties) => {
        const orgLogo = replaceOrgLogo(content);
        content = orgLogo || content
        const signName = replaceSignName(content, properties);
        content = signName || content
        const signImage = replaceSignImage(content, properties);
        content = signImage || content
        const orgTitle = replaceOrganization(content);
        content = orgTitle || content
        const itemContent = replacePlaceholders(content);
        content = itemContent || content
        const subtotalContent = replaceSubtotal(content)
        content = subtotalContent || content
        const discountContent = replaceDiscount(content)
        content = discountContent || content
        const taxContent = replaceTax(content)
        content = taxContent || content
        const adjustmentContent = replaceAdjustment(content)
        content = adjustmentContent || content
        const grandtotalContent = replaceGrandtotal(content)
        content = grandtotalContent || content
        const totalInWordContent = replaceTotalInWord(content)
        content = totalInWordContent || content
        const totalItems = replaceTotalItems(content)
        content = totalItems || content
        const totalTaxAmount = replaceTotalTaxAmount(content)
        content = totalTaxAmount || content
        let imgOldUrl = 'https://digylax-gallery.s3.amazonaws.com/'
        let imgNewUrl = 'https://d3garweb4bf7l8.cloudfront.net/'
        content = content.replaceAll(imgOldUrl, imgNewUrl || '-')
        const regex = /\$\{([^}]+)\}/g;
        const matches = [];
        let match;
        while ((match = regex.exec(content)) !== null) {
            matches.push(match[1]);
            let mt = match[1];
            let key = mt.split('.')[0];
            let val = mt.split('.')[1];
            let selectedField;
            let type;
            let _field;
            if (key === 'ORGANIZATION') {
                selectedField = val
                if (val === 'Organization Name')
                    selectedField = changeCase(val)?.replaceAll(' ', '')
                if (val === 'Zip Code')
                    selectedField = val?.replaceAll(' ', '_')
                _field = currentOrg[selectedField]
            } else {
                selectedField = val?.replaceAll(' ', '_')
                if (selectedField === 'CreatedAt') {
                    _field = formatDateYMD(rowData.createdAt)
                } else {
                    type = typeof (selectedRowData[selectedField])
                    if (type === 'object') {
                        _field = selectedRowData[selectedField]['name']
                    } else if (type === 'string' || type === 'number') {
                        _field = selectedRowData[selectedField]
                    }
                }
            }
            _field = _field === undefined ? '-' : _field
            let _mt = '${' + mt + '}'
            content = content.replaceAll(_mt, _field)
        }
        return content
    }

    const formHandler = (e) => {
        setShowLoader(true)
        const { value } = e?.target;
        setSelectedTemplateIndex(value);
        let updatedContent = getDynamicContent(templateData?.[value]?.content, templateData?.[value]?.templateProperties)
        setSelectedContent(updatedContent)
    }

    useEffect(() => {
        if (navbarList?.length) {
            let id = navbarList?.filter(item => item.name === 'Quotes')?.[0]?._id
            if (id) {
                dispatch(getModuleByIdStart(id));
            }
        }
    }, [navbarList]);

    useEffect(() => {
        if (formList?.length > 0) {
            setFieldList([]);
            let sections = formList?.[0]?.fields?.sections;
            for (var i = 0; i < sections.length; i++) {
                if (sections[i].dropped_list) {
                    let list = sections[i].dropped_list
                    let o_val = Object.values(list)
                    for (var j = 0; j < o_val.length; j++) {
                        for (var k = 0; k < o_val[j].length; k++) {
                            let _value = o_val[j][k];
                            setFieldList(list => [...list, _value])
                        }
                    }
                }
            }
        }
    }, [formList])

    useEffect(() => {
        if (fieldList?.length > 0) {
            let fields = fieldList
                .map(data => ({ key: data.extra_fields.field_label, value: data.extra_fields.field_label }))
        }
    })

    const parentRef = useRef(null);
    const ExportPdf = () => { }

    const setLoaderStatus = (val) => {
        setShowLoader(false)
        setIsInitialLoad(false);
    }

    return (
        <>
            <Modal
                show={showPrintExportModal}
                onHide={() => setShowPrintExportModal(false)}
                backdrop="static"
                keyboard={false}
                className="modal-xl"
            >
                <Modal.Header closeButton>
                    <h4>{printExportModalTitle}</h4>
                </Modal.Header>
                <Modal.Body
                    style={{ height: '600px', maxHeight: '600px', overflowY: 'scroll' }}>
                    <div className="row">
                        <div className="col-3">
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Choose Quote Template</Form.Label>
                                    <Form.Select
                                        name="selectedTemplateIndex"
                                        required
                                        value={selectedTemplateIndex}
                                        onChange={formHandler}
                                    >
                                        <option value="" disabled>None</option>
                                        {templateData && templateData.length > 0 &&
                                            templateData.map((data, index) => (
                                                <option key={data._id} value={index}>{data.templateName}</option>
                                            ))
                                        }
                                    </Form.Select>
                                </Form.Group>
                            </Form>
                            <div className="btn-group d-none">
                                <button type="button" className="btn btn-primary btn-blue"
                                    onClick={() => ExportPdf()}>
                                    Export
                                </button>
                                <button type="button" className="btn btn-outline-primary btn-blue"
                                    onClick={() => setShowPrintExportModal(false)}
                                >Cancel</button>
                            </div>
                        </div>
                        <div className="col-9" style={{ borderLeft: '1px solid lightgrey' }}>
                            <Loader isVisible={showLoader} isModal={true} overall={false} />
                            {selectedContent &&
                                <PdfPreviewer
                                    selectedContent={selectedContent}
                                    showLoader={showLoader}
                                    setShowLoader={setLoaderStatus}
                                    setParentRef={(ref) => (parentRef.current = ref)}
                                    setIsInitialLoad={setIsInitialLoad}
                                />
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export const ExportSoPdf = ({
    showPrintExportModal,
    setShowPrintExportModal,
    templateData,
    selectedRowData,
    printExportModalTitle,
    rowData,
    id,
    selectedRowTableData
}) => {
    const dispatch = useDispatch();
    let currentOrgName = getItem('user')?.organization?.organizationName;
    let currentOrg = useSelector((state) => state?.org)?.companyData?.[0];
    let navbarList = useSelector((state) => state?.forms)?.navbarList;
    let formList = useSelector((state) => state?.forms)?.modules;
    let currentCurrencyData = useSelector((state) => state?.currency)?.data?.[0];

    let [selectedContent, setSelectedContent] = useState('');
    let [selectedTemplateIndex, setSelectedTemplateIndex] = useState('')
    let [fieldList, setFieldList] = useState([]);
    let [showLoader, setShowLoader] = useState(false);
    let [isInitialLoad, setIsInitialLoad] = useState(false);

    useEffect(() => {
        // dispatch(getTemplateStart(id))
        setIsInitialLoad(true);
        if (templateData?.length) {
            setShowLoader(true)
            let defaultTemplateIndex = templateData?.findIndex((x) => x.is_default === true);
            defaultTemplateIndex = defaultTemplateIndex !== -1 ? defaultTemplateIndex : 0;
            if (defaultTemplateIndex >= 0) {
                setSelectedTemplateIndex(defaultTemplateIndex);
                let updatedContent = getDynamicContent(templateData?.[defaultTemplateIndex]?.content, templateData?.[defaultTemplateIndex]?.templateProperties)
                setSelectedContent(updatedContent)
            }
        }
    }, [])

    const formatNumber = (amount) => {
        return new Intl.NumberFormat(currentCurrencyData?.digit_format, {
            style: "decimal",
            minimumFractionDigits: currentCurrencyData?.decimal_place,
            maximumFractionDigits: currentCurrencyData?.decimal_place,
        }).format(amount);
    };

    const changeCase = (str) => str.charAt(0).toLowerCase() + str.slice(1);

    const cleanPlaceholders = (content) => {
        return content.replace(/\${(.*?)}/g, "$1");
    };

    const replaceOrganization = (content) => {
        content = content.replaceAll('${current_org}', currentOrgName || '-')
        return content
    }

    const replaceSubtotal = (content) => {
        let formattedTotal = formatNumber(selectedRowData?.aggregate_list?.Sub_Total)
        content = content.replaceAll('${Sub Total}', formattedTotal || '-')
        return content
    }

    const replaceDiscount = (content) => {
        content = content.replaceAll('${Discount}', selectedRowData?.aggregate_list?.Discount)
        return content
    }

    const calculateAmount = (percentage) => {
        let val = Number(selectedRowData?.aggregate_list?.Sub_Total) - Number(selectedRowData?.aggregate_list?.Discount || 0)
        let amt = (percentage / 100) * val;
        return formatNumber(amt)
    };

    const replaceTax = (content) => {
        // content = content.replaceAll('${Tax}', selectedRowData?.aggregate_list?.Tax)
        content = content.replaceAll('${Tax Percentage}', selectedRowData?.aggregate_list?.Tax ? selectedRowData?.aggregate_list?.Tax + '%' : '-')
        content = content.replaceAll('${Tax Amount}', selectedRowData?.aggregate_list?.Tax ? calculateAmount(selectedRowData?.aggregate_list?.Tax) : '-')
        return content
    }

    const replaceAdjustment = (content) => {
        content = content.replaceAll('${Adjustment}', formatNumber(selectedRowData?.aggregate_list?.Adjustment) || '-')
        return content
    }

    const replaceGrandtotal = (content) => {
        let formattedTotal = formatNumber(selectedRowData?.aggregate_list?.Grant_Total)
        content = content.replaceAll('${Grand Total}', formattedTotal || '-')
        content = content.replaceAll('${Symbol}', ` ${currentCurrencyData?.currency_code} ` || '-')
        return content
    }

    const replaceTotalInWord = (content) => {
        if (selectedRowData?.aggregate_list?.Grant_Total) {
            content = content.replaceAll('${TotalInWords}', convertToIndianWords(selectedRowData?.aggregate_list?.Grant_Total))
            return content
        }
    }

    const replaceTotalItems = (content) => {
        content = content.replaceAll('${TotalItems}', selectedRowData?.table_data?.length)
        return content
    }

    const replaceTotalTaxAmount = (content) => {
        const totalAmount = selectedRowTableData?.rowTax.reduce((sum, item) => {
            const amount = Number(item.tax_amount);
            return !isNaN(amount) && item.tax_amount !== "" ? sum + amount : sum;
        }, 0);
        content = content.replaceAll('${TotalTaxAmount}', currentCurrencyData?.currency_code + ' ' + formatNumber(totalAmount))
        return content
    }

    const replaceTableData = (content, i) => {
        const regex = /\${SALES ORDERS\.Item\.([^}]+)}/g;
        let match; const matches = [];
        content = content.replaceAll('${SALES ORDERS.item.S.No}', i + 1)
        while ((match = regex.exec(content)) !== null) {
            matches.push(match[0]);
            let mt = match[0];
            mt = cleanPlaceholders(mt)
            let selectedField = mt.split('.')[2]?.replaceAll(' ', '_')
            let type = typeof (selectedRowData?.table_data[i]?.[selectedField])
            let _field;
            if (type === 'object') {
                _field = selectedRowData?.table_data[i]?.[selectedField]['name']
            } else if (type === 'string' || type === 'number') {
                if (mt === "SALES ORDERS.Item.Total" || mt === "SALES ORDERS.Item.List Price") {
                    // _field = formatNumber(selectedRowData?.table_data[i]?.[selectedField])
                    _field = selectedRowData?.table_data[i]?.[selectedField]
                } else if (mt === "SALES ORDERS.Item.Discount") {
                    if (selectedRowTableData?.rowDiscount?.[i].discount_type === "percentage") {
                        _field = formatNumber(selectedRowTableData?.rowDiscount?.[i].discount_amount)
                    } else {
                        _field = selectedRowData?.table_data[i]?.[selectedField]
                    }
                } else if (mt === "SALES ORDERS.Item.Tax") {
                    _field = selectedRowTableData?.rowTax?.[i].tax_amount ? `${formatNumber(selectedRowTableData?.rowTax?.[i].tax_amount)} (${selectedRowData?.table_data[i]?.[selectedField]}%)` : ''
                } else {
                    _field = selectedRowData?.table_data[i]?.[selectedField]
                }
            }
            let _mt = '${' + mt + '}'
            _field = _field === undefined ? '-' : _field
            content = content.replaceAll(_mt, _field)
        }
        return content
    }

    const replaceElementsByClassMultipleTimes = (htmlString, className) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        const targetElements = doc.getElementsByClassName(className);
        Array.from(targetElements).forEach((el) => {
            let repeatedElements = "";
            for (let i = 0; i < selectedRowData?.table_data?.length; i++) {
                let replacedContent = replaceTableData(targetElements[0].outerHTML, i)
                repeatedElements += replacedContent;
            }
            el.outerHTML = repeatedElements;
        });
        return doc.body.innerHTML;
    };

    const replacePlaceholders = (content) => {
        if (selectedRowData?.table_data?.length > 0) {
            const extractedTableRow = replaceElementsByClassMultipleTimes(content, 'product-item-table-row')
            content = extractedTableRow || content
            selectedRowData?.table_data?.forEach((element, index) => {
                const regex = /\${SALES ORDERS\.Item\.([^}]+)}/g;
                let match; const matches = [];
                while ((match = regex.exec(content)) !== null) {
                    matches.push(match[0]);
                    let mt = match[0];
                    mt = cleanPlaceholders(mt)
                    let selectedField = mt.split('.')[2]?.replaceAll(' ', '_')
                    let type = typeof (element?.[selectedField])
                    let _field;
                    if (type === 'object') {
                        _field = element?.[selectedField]['name']
                    } else if (type === 'string' || type === 'number') {
                        _field = element?.[selectedField]
                    }
                    let _mt = '${' + mt + '}'
                    _field = _field === undefined ? '-' : _field
                    content = content.replaceAll(_mt, _field)
                }
            });
        } else {
            content = null
        }
        return content
    };

    const getDynamicContent = (content) => {
        const orgTitle = replaceOrganization(content);
        content = orgTitle || content
        const itemContent = replacePlaceholders(content);
        content = itemContent || content
        const subtotalContent = replaceSubtotal(content)
        content = subtotalContent || content
        const discountContent = replaceDiscount(content)
        content = discountContent || content
        const taxContent = replaceTax(content)
        content = taxContent || content
        const adjustmentContent = replaceAdjustment(content)
        content = adjustmentContent || content
        const grandtotalContent = replaceGrandtotal(content)
        content = grandtotalContent || content
        const totalInWordContent = replaceTotalInWord(content)
        content = totalInWordContent || content
        const totalItems = replaceTotalItems(content)
        content = totalItems || content
        const totalTaxAmount = replaceTotalTaxAmount(content)
        content = totalTaxAmount || content

        const regex = /\$\{([^}]+)\}/g;
        const matches = [];
        let match;
        while ((match = regex.exec(content)) !== null) {
            matches.push(match[1]);
            let mt = match[1];
            let key = mt.split('.')[0];
            let val = mt.split('.')[1];
            let selectedField;
            let type;
            let _field;
            if (key === 'ORGANIZATION') {
                selectedField = val
                if (val === 'Organization Name')
                    selectedField = changeCase(val)?.replaceAll(' ', '')
                if (val === 'Zip Code')
                    selectedField = val?.replaceAll(' ', '_')
                _field = currentOrg[selectedField]
            } else {
                selectedField = val?.replaceAll(' ', '_')
                if (selectedField === 'CreatedAt') {
                    _field = formatDateYMD(rowData.createdAt)
                } else {
                    type = typeof (selectedRowData[selectedField])
                    if (type === 'object') {
                        _field = selectedRowData[selectedField]['name']
                    } else if (type === 'string' || type === 'number') {
                        _field = selectedRowData[selectedField]
                    }
                }
            }
            _field = _field === undefined ? '-' : _field
            let _mt = '${' + mt + '}'
            content = content.replaceAll(_mt, _field)
        }
        return content
    }

    const formHandler = (e) => {
        setSelectedContent('')
        setShowLoader(true)
        const { value } = e?.target;
        setSelectedTemplateIndex(value);
        let updatedContent = getDynamicContent(templateData?.[value]?.content)
        setSelectedContent(updatedContent)
    }

    useEffect(() => {
        if (navbarList?.length) {
            let id = navbarList?.filter(item => item.name === 'Sales Orders')?.[0]?._id
            if (id) {
                dispatch(getModuleByIdStart(id));
            }
        }
    }, [navbarList]);

    useEffect(() => {
        if (formList?.length > 0) {
            setFieldList([]);
            let sections = formList?.[0]?.fields?.sections;
            for (var i = 0; i < sections.length; i++) {
                if (sections[i].dropped_list) {
                    let list = sections[i].dropped_list
                    let o_val = Object.values(list)
                    for (var j = 0; j < o_val.length; j++) {
                        for (var k = 0; k < o_val[j].length; k++) {
                            let _value = o_val[j][k];
                            setFieldList(list => [...list, _value])
                        }
                    }
                }
            }
        }
    }, [formList])

    useEffect(() => {
        if (fieldList?.length > 0) {
            let fields = fieldList
                .map(data => ({ key: data.extra_fields.field_label, value: data.extra_fields.field_label }))
        }
    })

    const parentRef = useRef(null);
    const ExportPdf = () => { }

    const setLoaderStatus = (val) => {
        setShowLoader(false)
        setIsInitialLoad(false);
    }

    return (
        <>
            <Modal
                show={showPrintExportModal}
                onHide={() => setShowPrintExportModal(false)}
                backdrop="static"
                keyboard={false}
                className="modal-xl"
            >
                <Modal.Header closeButton>
                    <h4>{printExportModalTitle}</h4>
                </Modal.Header>
                <Modal.Body
                    style={{ height: '600px', maxHeight: '600px', overflowY: 'scroll' }}>
                    <div className="row">
                        <div className="col-3">
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Choose Sales Order Template</Form.Label>
                                    <Form.Select
                                        name="selectedTemplateIndex"
                                        required
                                        value={selectedTemplateIndex}
                                        onChange={formHandler}
                                    >
                                        <option value="" disabled>None</option>
                                        {templateData && templateData.length > 0 &&
                                            templateData.map((data, index) => (
                                                <option key={data._id} value={index}>{data.templateName}</option>
                                            ))
                                        }
                                    </Form.Select>
                                </Form.Group>
                            </Form>
                            <div className="btn-group d-none">
                                <button type="button" className="btn btn-primary btn-blue"
                                    onClick={() => ExportPdf()}>
                                    Export
                                </button>
                                <button type="button" className="btn btn-outline-primary btn-blue"
                                    onClick={() => setShowPrintExportModal(false)}
                                >Cancel</button>
                            </div>
                        </div>
                        <div className="col-9" style={{ borderLeft: '1px solid lightgrey' }}>
                            <Loader isVisible={showLoader} isModal={true} overall={false} />
                            {selectedContent &&
                                <PdfPreviewer
                                    selectedContent={selectedContent}
                                    showLoader={showLoader}
                                    setShowLoader={setLoaderStatus}
                                    setParentRef={(ref) => (parentRef.current = ref)}
                                    setIsInitialLoad={setIsInitialLoad}
                                />
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export const ExportInvPdf = ({
    showPrintExportModal,
    setShowPrintExportModal,
    // templateData,
    selectedRowData,
    printExportModalTitle,
    rowData,
    id,
    selectedRowTableData
}) => {
    const dispatch = useDispatch();
    let currentOrgName = getItem('user')?.organization?.organizationName;
    let templateData = useSelector((state) => state?.template)?.data;
    let currentOrg = useSelector((state) => state?.org)?.companyData?.[0];
    let navbarList = useSelector((state) => state?.forms)?.navbarList;
    let formList = useSelector((state) => state?.forms)?.modules;
    let currentCurrencyData = useSelector((state) => state?.currency)?.data?.[0];

    let [selectedContent, setSelectedContent] = useState('');
    let [selectedTemplateIndex, setSelectedTemplateIndex] = useState('')
    let [fieldList, setFieldList] = useState([]);
    let [showLoader, setShowLoader] = useState(false)
    let [isInitialLoad, setIsInitialLoad] = useState(false);

    useEffect(() => {
        // dispatch(getTemplateStart(id))
        setIsInitialLoad(true);
        if (templateData?.length) {
            setShowLoader(true)
            let defaultTemplateIndex = templateData?.findIndex((x) => x.is_default === true);
            defaultTemplateIndex = defaultTemplateIndex !== -1 ? defaultTemplateIndex : 0;
            if (defaultTemplateIndex >= 0) {
                setSelectedTemplateIndex(defaultTemplateIndex);
                let updatedContent = getDynamicContent(templateData?.[defaultTemplateIndex]?.content, templateData?.[defaultTemplateIndex]?.templateProperties)
                setSelectedContent(updatedContent)
            }
        }
    }, [])

    const formatNumber = (amount) => {
        return new Intl.NumberFormat(currentCurrencyData?.digit_format, {
            style: "decimal",
            minimumFractionDigits: currentCurrencyData?.decimal_place,
            maximumFractionDigits: currentCurrencyData?.decimal_place,
        }).format(amount);
    };

    const changeCase = (str) => str.charAt(0).toLowerCase() + str.slice(1);

    const cleanPlaceholders = (content) => {
        return content.replace(/\${(.*?)}/g, "$1");
    };

    const replaceOrgLogo = (content) => {
        let element = `<img src=${currentOrg?.profilePicture} alt="org logo" style="width: 150px;" />`
        content = content.replaceAll('${org_logo}', element || '-')
        return content
    }

    const replaceSignName = (content, properties) => {
        content = content.replaceAll('${signature_name}', properties?.other_details?.document_summary?.signature?.signature_name || '')
        return content
    }

    const replaceSignImage = (content, properties) => {
        let element = `<img src="${properties?.other_details?.document_summary?.signature?.signature_image?.fileimage}" style="max-width: 240px; max-height: 240px;" />`
        content = content.replaceAll('${signature_image}', element || '')
        return content
    }

    const replaceOrganization = (content) => {
        content = content.replaceAll('${current_org}', currentOrgName || '-')
        return content
    }

    const replaceSubtotal = (content) => {
        // content = content.replaceAll('${Sub Total}', selectedRowData?.aggregate_list?.Sub_Total || '-')
        let formattedTotal = formatNumber(selectedRowData?.aggregate_list?.Sub_Total)
        content = content.replaceAll('${Sub Total}', formattedTotal || '-')
        return content
    }

    const replaceDiscount = (content) => {
        content = content.replaceAll('${Discount}', selectedRowData?.aggregate_list?.Discount)
        return content
    }

    const calculateAmount = (percentage) => {
        let val = Number(selectedRowData?.aggregate_list?.Sub_Total) - Number(selectedRowData?.aggregate_list?.Discount || 0)
        let amt = (percentage / 100) * val;
        return formatNumber(amt)
    };

    const replaceTax = (content) => {
        // content = content.replaceAll('${Tax}', selectedRowData?.aggregate_list?.Tax)
        content = content.replaceAll('${Tax Percentage}', selectedRowData?.aggregate_list?.Tax ? selectedRowData?.aggregate_list?.Tax + '%' : '-')
        content = content.replaceAll('${Tax Amount}', selectedRowData?.aggregate_list?.Tax ? calculateAmount(selectedRowData?.aggregate_list?.Tax) : '-')
        return content
    }

    const replaceAdjustment = (content) => {
        content = content.replaceAll('${Adjustment}', formatNumber(selectedRowData?.aggregate_list?.Adjustment) || '-')
        return content
    }

    const replaceGrandtotal = (content) => {
        // content = content.replaceAll('${Grand Total}', selectedRowData?.aggregate_list?.Grant_Total)
        let formattedTotal = formatNumber(selectedRowData?.aggregate_list?.Grant_Total)
        content = content.replaceAll('${Grand Total}', formattedTotal || '-')
        content = content.replaceAll('${Symbol}', ` ${currentCurrencyData?.currency_code} ` || '-')
        return content
    }

    const replacePaymentMade = (content) => {
        content = content.replaceAll('<tr style="height: 10px;"><td valign="middle">Payment Made</td><td valign="middle" style="width: 110px; color: red;">(-) ${Payment Made}</td></tr>', '')
        return content
    }

    const replaceBalanceDue = (content) => {
        // content = content.replaceAll('${Balance Due}', selectedRowData?.aggregate_list?.Grant_Total)
        let formattedTotal = formatNumber(selectedRowData?.aggregate_list?.Grant_Total)
        content = content.replaceAll('${Balance Due}', formattedTotal || '-')
        content = content.replaceAll('${Symbol}', ` ${currentCurrencyData?.currency_code} ` || '-')
        return content
    }

    const replaceTotalInWord = (content) => {
        if (selectedRowData?.aggregate_list?.Grant_Total) {
            content = content.replaceAll('${TotalInWords}', convertToIndianWords(selectedRowData?.aggregate_list?.Grant_Total))
            return content
        }
    }

    const replaceTotalItems = (content) => {
        content = content.replaceAll('${TotalItems}', selectedRowData?.table_data?.length)
        return content
    }

    const replaceTotalTaxAmount = (content) => {
        const totalAmount = selectedRowTableData?.rowTax.reduce((sum, item) => {
            const amount = Number(item.tax_amount);
            return !isNaN(amount) && item.tax_amount !== "" ? sum + amount : sum;
        }, 0);
        content = content.replaceAll('${TotalTaxAmount}', currentCurrencyData?.currency_code + ' ' + formatNumber(totalAmount))
        return content
    }

    const replaceTableData = (content, i) => {
        const regex = /\${INVOICES\.Item\.([^}]+)}/g;
        let match; const matches = [];
        content = content.replaceAll('${INVOICES.item.S.No}', i + 1)
        while ((match = regex.exec(content)) !== null) {
            matches.push(match[0]);
            let mt = match[0];
            mt = cleanPlaceholders(mt)
            let selectedField = mt.split('.')[2]?.replaceAll(' ', '_')
            let type = typeof (selectedRowData?.table_data[i]?.[selectedField])
            let _field;
            if (type === 'object') {
                _field = selectedRowData?.table_data[i]?.[selectedField]['name']
            } else if (type === 'string' || type === 'number') {
                // _field = selectedRowData?.table_data[i]?.[selectedField]
                if (mt === "INVOICES.Item.Total" || mt === "INVOICES.Item.List Price") {
                    // _field = formatNumber(selectedRowData?.table_data[i]?.[selectedField])
                    _field = selectedRowData?.table_data[i]?.[selectedField]
                } else if (mt === "INVOICES.Item.Discount") {
                    if (selectedRowTableData?.rowDiscount?.[i].discount_type === "percentage") {
                        _field = formatNumber(selectedRowTableData?.rowDiscount?.[i].discount_amount)
                    } else {
                        _field = selectedRowData?.table_data[i]?.[selectedField]
                    }
                } else if (mt === "INVOICES.Item.Tax") {
                    _field = selectedRowTableData?.rowTax?.[i].tax_amount ? `${formatNumber(selectedRowTableData?.rowTax?.[i].tax_amount)} (${selectedRowData?.table_data[i]?.[selectedField]}%)` : ''
                } else {
                    _field = selectedRowData?.table_data[i]?.[selectedField]
                }
            }
            let _mt = '${' + mt + '}'
            _field = _field === undefined ? '-' : _field
            content = content.replaceAll(_mt, _field)
        }
        return content
    }

    const replaceElementsByClassMultipleTimes = (htmlString, className) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        const targetElements = doc.getElementsByClassName(className);
        Array.from(targetElements).forEach((el) => {
            let repeatedElements = "";
            for (let i = 0; i < selectedRowData?.table_data?.length; i++) {
                let replacedContent = replaceTableData(targetElements[0].outerHTML, i)
                repeatedElements += replacedContent;
            }
            el.outerHTML = repeatedElements;
        });
        return doc.body.innerHTML;
    };

    const replacePlaceholders = (content) => {
        if (selectedRowData?.table_data?.length > 0) {
            const extractedTableRow = replaceElementsByClassMultipleTimes(content, 'product-item-table-row')
            content = extractedTableRow || content
            selectedRowData?.table_data?.forEach((element, index) => {
                const regex = /\${INVOICES\.Item\.([^}]+)}/g;
                let match; const matches = [];
                while ((match = regex.exec(content)) !== null) {
                    matches.push(match[0]);
                    let mt = match[0];
                    mt = cleanPlaceholders(mt)
                    let selectedField = mt.split('.')[2]?.replaceAll(' ', '_')
                    let type = typeof (element?.[selectedField])
                    let _field;
                    if (type === 'object') {
                        _field = element?.[selectedField]['name']
                    } else if (type === 'string' || type === 'number') {
                        _field = element?.[selectedField]
                    }
                    let _mt = '${' + mt + '}'
                    _field = _field === undefined ? '-' : _field
                    content = content.replaceAll(_mt, _field)
                }
            });
        } else {
            content = null
        }
        return content
    };

    const getDynamicContent = (content, properties) => {
        const orgLogo = replaceOrgLogo(content);
        content = orgLogo || content
        const signName = replaceSignName(content, properties);
        content = signName || content
        const signImage = replaceSignImage(content, properties);
        content = signImage || content
        const orgTitle = replaceOrganization(content);
        content = orgTitle || content
        const itemContent = replacePlaceholders(content);
        content = itemContent || content
        const subtotalContent = replaceSubtotal(content)
        content = subtotalContent || content
        const discountContent = replaceDiscount(content)
        content = discountContent || content
        const taxContent = replaceTax(content)
        content = taxContent || content
        const adjustmentContent = replaceAdjustment(content)
        content = adjustmentContent || content
        const grandtotalContent = replaceGrandtotal(content)
        content = grandtotalContent || content
        const paymentMadeContent = replacePaymentMade(content)
        content = paymentMadeContent || content
        const balanceDueContent = replaceBalanceDue(content)
        content = balanceDueContent || content
        const totalInWordContent = replaceTotalInWord(content)
        content = totalInWordContent || content
        const totalItems = replaceTotalItems(content)
        content = totalItems || content
        const totalTaxAmount = replaceTotalTaxAmount(content)
        content = totalTaxAmount || content

        const regex = /\$\{([^}]+)\}/g;
        const matches = [];
        let match;
        while ((match = regex.exec(content)) !== null) {
            matches.push(match[1]);
            let mt = match[1];
            let key = mt.split('.')[0];
            let val = mt.split('.')[1];
            let selectedField;
            let type;
            let _field;
            if (key === 'ORGANIZATION') {
                selectedField = val
                if (val === 'Organization Name')
                    selectedField = changeCase(val)?.replaceAll(' ', '')
                if (val === 'Zip Code')
                    selectedField = val?.replaceAll(' ', '_')
                _field = currentOrg[selectedField]
            } else {
                selectedField = val?.replaceAll(' ', '_')
                if (selectedField === 'CreatedAt') {
                    _field = formatDateYMD(rowData.createdAt)
                } else {
                    type = typeof (selectedRowData[selectedField])
                    if (type === 'object') {
                        _field = selectedRowData[selectedField]['name']
                    } else if (type === 'string' || type === 'number') {
                        _field = selectedRowData[selectedField]
                    }
                }
            }
            _field = _field === undefined ? '-' : _field
            let _mt = '${' + mt + '}'
            content = content.replaceAll(_mt, _field)
        }
        return content
    }

    const formHandler = (e) => {
        setSelectedContent('')
        setShowLoader(true)
        const { value } = e?.target;
        setSelectedTemplateIndex(value);
        let updatedContent = getDynamicContent(templateData?.[value]?.content, templateData?.[value]?.templateProperties)
        setSelectedContent(updatedContent)
    }

    useEffect(() => {
        if (navbarList?.length) {
            let id = navbarList?.filter(item => item.name === 'Invoices')?.[0]?._id
            if (id) {
                dispatch(getModuleByIdStart(id));
            }
        }
    }, [navbarList]);

    useEffect(() => {
        if (formList?.length > 0) {
            setFieldList([]);
            let sections = formList?.[0]?.fields?.sections;
            for (var i = 0; i < sections.length; i++) {
                if (sections[i].dropped_list) {
                    let list = sections[i].dropped_list
                    let o_val = Object.values(list)
                    for (var j = 0; j < o_val.length; j++) {
                        for (var k = 0; k < o_val[j].length; k++) {
                            let _value = o_val[j][k];
                            setFieldList(list => [...list, _value])
                        }
                    }
                }
            }
        }
    }, [formList])

    useEffect(() => {
        if (fieldList?.length > 0) {
            let fields = fieldList
                .map(data => ({ key: data.extra_fields.field_label, value: data.extra_fields.field_label }))
        }
    })

    const parentRef = useRef(null);
    const ExportPdf = () => { }

    const setLoaderStatus = (val) => {
        setShowLoader(false)
        setIsInitialLoad(false);
    }

    return (
        <>
            <Modal
                show={showPrintExportModal}
                onHide={() => setShowPrintExportModal(false)}
                backdrop="static"
                keyboard={false}
                className="modal-xl"
            >
                <Modal.Header closeButton>
                    <h4>{printExportModalTitle}</h4>
                </Modal.Header>
                <Modal.Body
                    style={{ height: '600px', maxHeight: '600px', overflowY: 'scroll' }}>
                    <div className="row">
                        <div className="col-3">
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Choose Invoice Template</Form.Label>
                                    <Form.Select
                                        name="selectedTemplateIndex"
                                        required
                                        value={selectedTemplateIndex}
                                        onChange={formHandler}
                                    >
                                        <option value="" disabled>None</option>
                                        {templateData && templateData.length > 0 &&
                                            templateData.map((data, index) => (
                                                <option key={data._id} value={index}>{data.templateName}</option>
                                            ))
                                        }
                                    </Form.Select>
                                </Form.Group>
                            </Form>
                            <div className="btn-group d-none">
                                <button type="button" className="btn btn-primary btn-blue"
                                    onClick={() => ExportPdf()}>
                                    Export
                                </button>
                                <button type="button" className="btn btn-outline-primary btn-blue"
                                    onClick={() => setShowPrintExportModal(false)}
                                >Cancel</button>
                            </div>
                        </div>
                        <div className="col-9" style={{ borderLeft: '1px solid lightgrey' }}>
                            <Loader isVisible={showLoader} isModal={true} overall={false} />
                            {selectedContent &&
                                <PdfPreviewer
                                    selectedContent={selectedContent}
                                    showLoader={showLoader}
                                    setShowLoader={setLoaderStatus}
                                    setParentRef={(ref) => (parentRef.current = ref)}
                                    setIsInitialLoad={setIsInitialLoad}
                                />
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
